import { render, staticRenderFns } from "./PhotoUpload.vue?vue&type=template&id=40a7d718&"
import script from "./PhotoUpload.vue?vue&type=script&lang=js&"
export * from "./PhotoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports